import Nullstack from 'nullstack';
export default function IconSquaresFilled({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-squares-filled",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "8",
    y: "8",
    width: "12",
    height: "12",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M8 14.5l6.492 -6.492"
  }), "   ", Nullstack.element("path", {
    d: "M13.496 20.004l6.504 -6.504l-6.504 6.504z"
  }), "   ", Nullstack.element("path", {
    d: "M8.586 19.414l10.827 -10.827"
  }), "   ", Nullstack.element("path", {
    d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }), " ");
}